<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">D/O分け</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="submit" class="ml-2">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="show = false" class="ml-2">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field label="D/O分け数量" type="number" v-model="count"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    count: 0
  }),
  methods: {
    submit() {
      this.$emit('submit', this.count)
      this.show = false
    },
    popup() {
      this.show = true
    }
  }
}
</script>